import { ThemeProvider } from 'styled-components/macro'
import { Container, Row, Col } from 'react-bootstrap'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Header from './components/Header'
import Main from './components/Main'
import SingleStake from './components/SingleStake'
import Footer from './components/Footer'
import theme from './theme'
import Web3ReactManager from './components/Web3ReactManager'
import { MainWrapper, TitleWrapper, Title, TitleShadow } from './Styled'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css'
import './assets/css/style.css'
import './assets/css/toastify.css'
import './assets/fonts/stylesheet.css'

function App(): JSX.Element {
  return (
    <Web3ReactManager>
      <ThemeProvider theme={theme}>
        <Router>
          <Header />
          <MainWrapper>
            <Container>
              <Row>
                <Col>
                  <TitleWrapper>
                    <Title>Staking DTO</Title>
                    <TitleShadow>Staking DTO</TitleShadow>
                  </TitleWrapper>
                </Col>
              </Row>
            </Container>
            <Routes>
              <Route path="/" element={<Main />} />
              <Route path="/stake/:slug" element={<SingleStake />} />
            </Routes>
          </MainWrapper>
          <Footer />
        </Router>
      </ThemeProvider>
    </Web3ReactManager>
  )
}

export default App
